// FR-A4: bounces a now-signed-in visitor back to `/desktop-auth` after a sign-in path that
// involves a full top-level redirect away from this app and back (Google, Microsoft, SSO) —
// those land on `/orgs` with no way to carry a `next` query param through the provider round
// trip, unlike the password/MFA path (`SignIn.tsx`'s own `next` handling, no redirect needed).
//
// `DesktopAuthPage` sets the breadcrumb before sending a signed-out visitor to `/signin`;
// `sessionStorage` (not `localStorage`) survives that top-level navigation in the same tab but
// is gone once the tab closes, so a stale breadcrumb from a long-abandoned attempt can't fire
// days later. Mounted once, app-wide, next to `ImpersonationBanner`.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../session";

export const DESKTOP_AUTH_RETURN_KEY = "grackle:desktop-auth-return";

export default function DesktopAuthReturn() {
  const { user, loading } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !user) return;
    const pending = sessionStorage.getItem(DESKTOP_AUTH_RETURN_KEY);
    if (!pending) return;
    sessionStorage.removeItem(DESKTOP_AUTH_RETURN_KEY);
    navigate(pending, { replace: true });
  }, [user, loading, navigate]);

  return null;
}
